<script setup>
import { computed } from 'vue';
import { getI18nKey } from 'dashboard/routes/dashboard/settings/helper/settingsHelper';
import ShowMore from 'dashboard/components/widgets/ShowMore.vue';
import { useI18n } from 'vue-i18n';
import { BaseTableRow, BaseTableCell } from 'dashboard/components-next/table';
import RowMenu from 'dashboard/components-next/polaris/cards/RowMenu.vue';
import { useSettingsRowMenu } from '../../components/useSettingsRowMenu';

const props = defineProps({
  webhook: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);
const { t } = useI18n();
const { rowMenuItems, rowMenuLabel } = useSettingsRowMenu();
const onAction = action => {
  if (action === 'edit') emit('edit', props.webhook);
  else emit('delete', props.webhook, props.index);
};
const subscribedEvents = computed(() => {
  const { subscriptions } = props.webhook;
  return subscriptions
    .map(event =>
      t(
        getI18nKey(
          'INTEGRATION_SETTINGS.WEBHOOK.FORM.SUBSCRIPTIONS.EVENTS',
          event
        )
      )
    )
    .join(', ');
});
</script>

<!-- Phase 9.9: the kit's table row — the endpoint (name first when it has one; a long URL wraps), the events
     under it, and the ⋮ menu (R2-9-4). -->
<template>
  <BaseTableRow :item="webhook">
    <BaseTableCell wrap class="break-all">
      <span class="block">{{ webhook.name || webhook.url }}</span>
      <span
        v-if="webhook.name"
        class="block font-normal text-polaris-muted-foreground"
      >
        {{ webhook.url }}
      </span>
      <span
        class="mt-1 block break-normal type-polaris-caption font-normal text-polaris-muted-foreground"
      >
        {{ $t('INTEGRATION_SETTINGS.WEBHOOK.SUBSCRIBED_EVENTS') }}:
        <ShowMore :text="subscribedEvents" :limit="60" />
      </span>
    </BaseTableCell>
    <BaseTableCell actions>
      <RowMenu
        :label="rowMenuLabel(webhook.name || webhook.url)"
        :items="rowMenuItems()"
        @action="onAction"
      />
    </BaseTableCell>
  </BaseTableRow>
</template>
